<template>
  <div class="searchresults">
    <Quicksearch v-bind:searching.sync="searching" v-bind:beforestart="callback" v-bind:callback="callback"/>
    <div class="container container-nopaddinghorizontal container-afterheader container-includefixedfooter">      
      <transition name="container-overlay">
        <div class="container-overlay" v-if="searching"></div>      
      </transition>
      <div class="container container-small">   
        <table  class="searchresults-table" v-if="$root.result && $root.result.Documents && $root.result.Documents.length > 0">
          <router-link 
            tag="tr" 
            v-for="r in $root.result.Documents" 
            v-bind:key="r.Contribution.Id"
            :to="{name: 'entry', params: {view: r.Contribution.FortemplateName, id: r.Contribution.Id}}"
          >
            <td><span class="label" v-html="$root.t(`template:${r.Contribution.FortemplateName}`)"></span></td>
            <template v-if="r.Contribution.FortemplateName === 'Person'">
              <td v-html="$root.j([r.Data.vorname.Content, r.Data.name.Content], ' ')"></td>
              <td>
                <p v-for="(p, pk) in r.Data.pseudonym.Content" v-bind:key="pk" v-if="p[0]" v-html="p[0]"></p>
              </td>
              <td v-html="r.Data.ort.Content"></td>
            </template>
            <template v-else>
              <td v-html="r.Data.titel.Content || r.Data.intitel.Content" colspan="3"></td>
            </template>
          </router-link>
        </table>
        <table  class="searchresults-table" v-else>
          <tr>
            <td>
                <p v-html="$root.t('search:noresults')"></p>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="footer footer-fixed" v-if="$root.result">
      <div class="container container-small container-nopadding">
        <div class="footer-col-wide">
          <a v-if="$root.result.Offset > 0" class="prev" v-on:click="page($event, -20)"></a>
          {{$root.result.Offset}} - {{$root.result.Offset + $root.result.Limit}} / {{$root.result.NumFound}}
          <a v-if="$root.result.Limit < $root.result.NumFound" class="next" v-on:click="page($event, 20)"></a>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  @import "../main";
  .searchresults {
    .fade-enter-active {
      transition: opacity .5s;
    }
    .fade-leave-active {
      position: absolute;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
      opacity: 0;
    }
    &-table {
      width: 100%;
      border-collapse: collapse;
      tr {
        border-bottom: 1px solid $border-active-color;
        transition: all 0.1s;
        &:first-child {
          border-top: 1px solid $border-active-color;
        }
        &:hover {
          background: $background-highlight;
        }
      }
      td {
        padding: $padding;
        vertical-align: top;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 25%;
        &:nth-child(2) {
          width: calc(50% - 80px);
        }
        &:first-child {
          width: 80px;
          padding-left: 0px;
        }
        p {
          margin: 0;
        }
        @include st() {
          &:nth-child(4) {
            display: none;
            width: calc(75% - 80px);
          }
          &:nth-child(2) {
            padding-left: 0;
            width: calc(100% - 80px);
          }
        }
        @include sm() {
          &:nth-child(3) {
            display: none;
          }
          &:nth-child(2) {
            width: calc(100% - 80px);
          }
        }
      }
    }
  }
</style>

<script>

import Quicksearch from '@/components/Quicksearch.vue'

export default {
  name: 'searchresults',
  components: {
    Quicksearch
  },
  data() {
    return {
      searching: false
    }
  },
  methods: {
    async page(e, offset) {
      e.preventDefault();
      this.searching = true;
      this.$root.formdata.offset += offset;
      console.log(this.$root.formdata.offset);
      this.$root.result = await this.$store.dispatch('post', {
                          mode: '/search', 
                          params: this.$root.formdata,
                          headers: {
                            'Content-type': 'application/json',
                          }
                      });
      this.searching = false;
      this.$forceUpdate();
      return false;
    },
    callback() {
      this.$forceUpdate();
    }
  }
}
</script>
